import { processingGroupIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const deleteProcessingGroup = {
  name: "deleteProcessingGroup" as const,
  input: z.object({ id: processingGroupIdFormat.schema }),
  output: z.null(),
};
